import Vue from 'vue';
import i18n from './i18n';
import App from './App.vue';
import store from '@/store/store';
import router from './router';
import '@/components/_globals';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { icons } from '@/assets/styles/fontawesome.js';

library.add(icons);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.prototype.$city = window.CITY || 5;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
